var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 31.5,
    stroke: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4997 32.5001C28.8343 32.5001 25.8476 29.5224 25.8331 25.8603C25.8476 29.5203 28.8364 32.5001 32.4997 32.5001ZM32.4997 32.5001C36.1741 32.5001 39.1663 29.5078 39.1663 25.8334M32.4997 32.5001C36.172 32.5001 39.1663 29.5057 39.1663 25.8334M39.1663 25.8334C39.1663 22.168 36.1886 19.1814 32.5266 19.1668C36.1866 19.1814 39.1663 22.1701 39.1663 25.8334ZM25.8331 25.8065C25.8476 22.1534 28.8197 19.1813 32.4728 19.1668C28.8217 19.1813 25.8476 22.1555 25.8331 25.8065Z",
    stroke: "#4DA8B7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0469 45.8333C21.0469 40.8586 26.0033 36.5 32.5002 36.5C26.4119 36.5 21.0469 40.481 21.0469 45.8333Z",
    stroke: "#4DA8B7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9344 43.2385C36.0521 43.4426 36.1845 43.6358 36.3288 43.8173C36.1851 43.6383 36.0533 43.4475 35.9367 43.2482L35.9319 43.2401L35.9269 43.232C35.643 42.7673 35.4328 42.2518 35.3063 41.7098C35.4318 42.246 35.6418 42.7628 35.9344 43.2385ZM45.8337 40.5001C45.8337 40.5023 45.8337 40.5044 45.8337 40.5066C45.832 39.1944 45.3404 37.9371 44.465 36.9601C43.4703 35.8052 42.0244 35.1705 40.5137 35.1668C42.0395 35.1706 43.4788 35.8233 44.4563 36.9341L44.4562 36.9341L44.4624 36.941C45.3415 37.9215 45.8337 39.1785 45.8337 40.5001ZM36.7909 36.6633C37.7871 35.6951 39.0923 35.1667 40.5003 35.1667C39.0939 35.1667 37.7895 35.7033 36.7909 36.6633ZM35.167 40.5001C35.167 39.5887 35.3932 38.7166 35.8165 37.9428C35.3945 38.7154 35.167 39.588 35.167 40.5001Z",
    stroke: "#4DA8B7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4993 41.4734H38.5127C37.966 41.4734 37.5127 41.0201 37.5127 40.4734C37.5127 39.9267 37.966 39.4734 38.5127 39.4734H42.4993C43.046 39.4734 43.4993 39.9267 43.4993 40.4734C43.4993 41.0201 43.046 41.4734 42.4993 41.4734Z",
    fill: "#4DA8B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 43.5133C39.9533 43.5133 39.5 43.0599 39.5 42.5133V38.5266C39.5 37.9799 39.9533 37.5266 40.5 37.5266C41.0467 37.5266 41.5 37.9799 41.5 38.5266V42.5133C41.5 43.0733 41.0467 43.5133 40.5 43.5133Z",
    fill: "#4DA8B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginUser);
export default __webpack_public_path__ + "static/media/login_user.68762bf6fa3a3a623fe00c344b39dcc4.svg";
export { ForwardRef as ReactComponent };